import { useAuthContext } from '@app/providers/AuthProvider';

// Re-export the auth context hook for convenience
export function useAuth() {
  return useAuthContext();
}
